module.exports = __webpack_public_path__ + "img/dcar-large.d435d59a.png";